/** Formats a notification's RFC 3339 timestamp as a human-readable local date and time. */
export function formatNotificationCreatedAt(rawTimestamp: string): string {
  const date = new Date(rawTimestamp);
  if (Number.isNaN(date.getTime())) {
    return rawTimestamp;
  }

  const today = new Date();
  const todayDay = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const notificationDay = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const dayDifference = (todayDay - notificationDay) / (24 * 60 * 60 * 1000);
  const dayLabel = dayDifference === 0 ? "(Today) " : dayDifference === 1 ? "(Yesterday) " : "";

  return `${dayLabel}${date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })}`;
}
